const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const normalizeSelection = (selection, textLength) => {
  if (
    !selection ||
    !Number.isInteger(selection.start) ||
    !Number.isInteger(selection.end)
  ) {
    return { start: textLength, end: textLength };
  }

  const start = clamp(selection.start, 0, textLength);
  const end = clamp(selection.end, 0, textLength);

  if (start <= end) {
    return { start, end };
  }

  return { start: end, end: start };
};

export const insertEmojiAtSelection = (text, selection, emoji) => {
  const safeText = typeof text === "string" ? text : "";
  const safeEmoji = typeof emoji === "string" ? emoji : "";

  if (!safeEmoji) {
    return {
      text: safeText,
      selection: normalizeSelection(selection, safeText.length),
    };
  }

  const normalizedSelection = normalizeSelection(selection, safeText.length);
  const before = safeText.slice(0, normalizedSelection.start);
  const after = safeText.slice(normalizedSelection.end);
  const nextText = `${before}${safeEmoji}${after}`;
  const cursor = before.length + safeEmoji.length;

  return {
    text: nextText,
    selection: { start: cursor, end: cursor },
  };
};

export default insertEmojiAtSelection;
